<header class="header" [ngClass]="{'is-search-mode': searchActive}">
    <div class="header-container container user-select-none">
        <div class="header-logo-wrap">
            <a class="header-logo" [href]="'/'">
                <img class="visible-lg-block" alt="YCharts logo" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='155px' height='21px' viewBox='-0.195 0 155 21' enable-background='new -0.195 0 155 21' xml:space='preserve'%3E%3Cpolygon fill='%230282E8' points='14.863,0.358 7.823,12.352 7.823,20.428 12.214,20.428 12.214,12.614 19.939,0.358 '/%3E%3Cpolygon fill='%230282E8' points='8.034,5.392 5.044,0.358 -0.195,0.358 5.697,9.646 '/%3E%3Cpath fill='%23FFFFFF' d='M32.348,21c-5.975,0-10.413-4.609-10.413-10.441V10.5c0-5.77,4.354-10.5,10.588-10.5 c3.831,0,6.121,1.278,8.008,3.133l-2.845,3.279c-1.565-1.422-3.16-2.292-5.189-2.292c-3.423,0-5.888,2.843-5.888,6.323V10.5 c0,3.48,2.406,6.382,5.888,6.382c2.32,0,3.742-0.929,5.336-2.377l2.844,2.872C38.587,19.607,36.264,21,32.348,21'/%3E%3Cpolygon fill='%23FFFFFF' points='59.338,20.65 59.338,12.502 51.1,12.502 51.1,20.65 46.633,20.65 46.633,0.35 51.1,0.35 51.1,8.383 59.338,8.383 59.338,0.35 63.805,0.35 63.805,20.65 '/%3E%3Cpath fill='%23FFFFFF' d='M79.625,5.57l-2.694,6.584h5.39L79.625,5.57z M85.772,20.65l-1.854-4.553h-8.585l-1.858,4.553h-4.553 l8.699-20.446h4.119L90.44,20.65H85.772z'/%3E%3Cpath fill='%23FFFFFF' d='M107.926,7.281c0-1.914-1.333-2.901-3.511-2.901h-4.438v5.829h4.523c2.177,0,3.423-1.161,3.423-2.872 L107.926,7.281L107.926,7.281z M107.839,20.65l-4.353-6.496h-3.511v6.496H95.51V0.35h9.28c4.788,0,7.656,2.523,7.656,6.7v0.06 c0,3.276-1.771,5.335-4.352,6.294l4.96,7.25h-5.223V20.65H107.839z'/%3E%3Cpolygon fill='%23FFFFFF' points='128.369,4.467 128.369,20.65 123.903,20.65 123.903,4.467 117.723,4.467 117.723,0.35 134.548,0.35 134.548,4.467 '/%3E%3Cpath fill='%23FFFFFF' d='M146.962,20.941c-3.074,0-6.18-1.073-8.612-3.248l2.642-3.161c1.823,1.509,3.74,2.465,6.062,2.465 c1.828,0,2.932-0.726,2.932-1.915v-0.059c0-1.131-0.696-1.713-4.09-2.582c-4.091-1.043-6.729-2.173-6.729-6.207V6.179 c0-3.682,2.957-6.12,7.103-6.12c2.963,0,5.481,0.927,7.543,2.579l-2.318,3.366c-1.804-1.248-3.567-2-5.277-2 c-1.714,0-2.612,0.782-2.612,1.769v0.059c0,1.333,0.871,1.77,4.379,2.668c4.119,1.074,6.44,2.553,6.44,6.092v0.061 C154.417,18.682,151.344,20.941,146.962,20.941'/%3E%3C/svg%3E">
                <img class="hidden-lg" alt="YCharts logo" src="data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.7752 0.462769L8.39917 13.0298V21.4898H12.9982V13.3038L21.0942 0.462769H15.7752Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0.462769L6.172 10.1938L8.619 5.73777L5.487 0.462769H0Z' fill='white'/%3E%3C/svg%3E">
            </a>
        </div>
        <div class="header-mainmenu user-select-none" [ngClass]="{show: mainMenuActive}">
            <ng-container *ngIf="!totalLockout">
                <ycn-nav-menu-list
                    class="header-mainmenu-item"
                    *ngFor="let menuItem of headerMainMenuConfig"
                    [config]="menuItem"
                ></ycn-nav-menu-list>
            </ng-container>
        </div>
        <div class="header-search">
            <ycn-top-bar-nav-autocomplete
                *ngIf="!totalLockout"
                class="field-input-group input-group dropdown show field-search compact"
                [ngClass]="{ 'is-centered': isDesktop }"
                [defaultResults]="defaultResults"
                (click)="searchActiveOn()">
            </ycn-top-bar-nav-autocomplete>
            <div class="header-search-close"
                 [ngClass]="{'show': searchActive}"
                 (click)="searchActiveOff()">
                 Cancel
            </div>
        </div>
        <div class="header-sidemenu user-select-none">
            <button *ngIf="USER.unpaidTrial" class="header-button btn btn-primary align-self-center" 
                (click)="scheduleDemo($event)">
                <span class="text-small text-nowrap" [textContent]="scheduleDemoText"></span>
            </button>
            <div *ngIf="!!USER.daysRemainingInTrial" class="sidemenu-item header-message">
                <span class="text-green align-items-center visible-xl-flex">
                    {{ USER.daysRemainingInTrial }} Days Remaining
                </span>
                <div class="d-flex align-items-center">
                    <div class="circle-stats text-green hidden-xl" style="--trialDaysRemaining: {{ USER.daysRemainingInTrial }}; --trialDaysTotal: 7" ycnTooltip [tooltipTitle]="USER.daysRemainingInTrial + ' Days Remaining'">{{ USER.daysRemainingInTrial }}</div>
                </div>
            </div>
            <div *ngIf="showTrial && !totalLockout"
                [class]="FREE_TRIAL_ITEM.itemClass">
                <a [class]="FREE_TRIAL_ITEM.linkClass"
                    [href]="FREE_TRIAL_ITEM.href" [textContent]="FREE_TRIAL_ITEM.text"></a>
            </div>
            <div class="sidemenu-item sidemenu-item-chat"
                 *ngIf="chatEnabled"
                 onclick="window.openHubSpotChat();"
                 ycnTooltip
                 [tooltipTitle]="'Chat with us'">
                <div class="sidemenu-icon text-green">
                    <svg ycnIcon [name]="'icon-chat'"></svg>
                </div>
            </div>
            <div class="sidemenu-item sidemenu-item-pendo"
                 *ngIf="USER.authenticated && !totalLockout"
                 ycnTooltip
                 [tooltipTitle]="'Resource Center'">
                <div class="pendo-widget">
                    <div class="sidemenu-icon pendo-widget-icon">
                        <svg ycnIcon [name]="'icon-pendo'"></svg>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="totalLockout">
                <div class="header-sidemenu-item visible-lg-flex">
                <span style="color: #ffce00; font-weight: 700; align-self: center">
                    SALES (866) 965-7552
                </span>
                </div>
                <div class="header-mainmenu user-select-none">
                    <ycn-nav-menu-list
                    class="header-mainmenu-item"
                    *ngFor="let menuItem of headerMainMenuConfig"
                    [config]="menuItem"
                    ></ycn-nav-menu-list>
                </div>
            </ng-container>
            <div *ngIf="!USER.authenticated" [class]="SIGN_IN_ITEM.itemClass">
                <a [class]="SIGN_IN_ITEM.linkClass"
                   [href]="nextLoginLink"
                   [textContent]="SIGN_IN_ITEM.text"></a>
            </div>
            <div *ngIf="USER.authenticated" class="sidemenu-item sidemenu-item-usermenu-toggler header-usermenu dropdown pendo-manage-account" data-test-id="user-menu-toggle"
                [ngClass]="{'is-active': userMenuActive}"
                (mouseenter)="setUserMenuActive(true)"
                (mouseleave)="setUserMenuActive(false)"
            >
                <div class="header-usermenu-toggler-wrap">
                    <div class="sidemenu-icon">
                        <svg ycnIcon [name]="'icon-user'">
                            <use xlink:href="#icon-user"></use>
                        </svg>
                    </div>
                    <div class="user-name visible-xl-block" [textContent]="formattedUserText"></div>
                </div>
                <ycn-user-menu
                    [userMenuActive]="userMenuActive"
                    (addErrorMessageHandler)="addErrorMessage($event)"
                >
                </ycn-user-menu>
            </div>
        </div>
        <div class="header-toggler">
            <div
                class="header-mainmenu-toggler-button"
                [ngClass]="{'is-active': mainMenuActive}"
                (click)="toggleMainMenuActive()">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
            </div>
        </div>
    </div>
</header>
@for (message of errorMessages; track $index) {
    <ng-container>
        <div class="page-message page-message-error">
            <div class="container">
              <div class="page-message-text" [innerHTML]="message"></div>
              <div class="page-message-actions">
                <div class="btn btn-xs btn-circle btn-transparent btn-close" (click)=removeErrorMessage($index)>
                    <span>
                      <svg ycnIcon [name]="'icon-close'">
                      </svg>
                    </span>
                </div>
              </div>
            </div>
        </div>
    </ng-container>
}
